import { IOrderRepository, OrderFilters } from '../domain/repositories/IOrderRepository'
import { OrderListEntity } from '../domain/entities/order.entity'

export class ListOrdersUseCase {
    private orderRepository: IOrderRepository

    constructor(orderRepository: IOrderRepository) {
        this.orderRepository = orderRepository
    }

    async execute(filters: OrderFilters): Promise<OrderListEntity> {
        return this.orderRepository.list(filters)
    }
}
